export default __webpack_public_path__ + "static/kasimpasa-logo-a9eef3f1c91be4a131828759f8bbc76e.png";